import { z } from 'zod';
import { textWithinLimit } from '@/shared/lib/validation';
import { getHttpUrl } from '@/shared/lib/httpUrl';

/** Максимальная длина текстового ответа пользователю */
export const CHAT_DIALOG_MESSAGE_MAX_LENGTH = 4000;

/** Максимальная длина подписи фотографий */
export const CHAT_PHOTO_CAPTION_MAX_LENGTH = 1024;

/** Предельное число фотографий в сообщении */
export const CHAT_MESSAGE_MAX_PHOTOS = 10;

/** Проверяет текст и фотографии ответа пользователю */
export const chatDialogSendMessageSchema = z.object({
    text: textWithinLimit(CHAT_DIALOG_MESSAGE_MAX_LENGTH,
        `Сообщение должно содержать не больше ${CHAT_DIALOG_MESSAGE_MAX_LENGTH} символов`, { trim: true }),
    photoUrls: z.array(textWithinLimit(2048)
        .refine((value) => Boolean(getHttpUrl(value)), {
            message: 'Некорректный адрес фотографии',
        }))
        .max(CHAT_MESSAGE_MAX_PHOTOS, 'Можно прикрепить не больше 10 фотографий')
        .optional(),
})
    .superRefine((value, context) => {
        if (!value.text && !(value.photoUrls?.length)) {
            context.addIssue({
                code: 'custom',
                path: ['text'],
                message: 'Введите сообщение или добавьте фотографии',
            });
        }

        if (value.photoUrls?.length && value.text.length > CHAT_PHOTO_CAPTION_MAX_LENGTH) {
            context.addIssue({
                code: 'custom',
                path: ['text'],
                message: `Подпись фотографий должна содержать не больше ${CHAT_PHOTO_CAPTION_MAX_LENGTH} символов`,
            });
        }
    });
